import React from 'react';
import Board from '@/modules/core/client/components/Board.js';
import { userType } from '@/modules/users/client/users.prop-types';
import { useTranslation } from 'react-i18next';

export default function Privacy() {
  const { t } = useTranslation('pages');

  return (
    <>
      <Board names="mountainforest">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 text-center">
              <br />
              <br />
              <h2>{t('Privacy')}</h2>
            </div>
          </div>
        </div>
      </Board>

      <section className="container container-spacer">
        <div className="row">
          <div
            className="col-xs-12 col-sm-offset-1 col-sm-10 col-md-offset-2 col-md-8"
            itemScope
            itemType="http://schema.org/Article"
          >
            <h1 itemProp="name">{t('Privacy Policy')}</h1>

            <p
              className="text-muted"
              itemProp="datePublished"
              dateTime="2025-09-08"
            >
              <time itemProp="dateModified" dateTime="2025-09-08">
                Effective Date: 08/09/2025
              </time>
              <br />
              {t('Jurisdiction: Republic of Ireland & European Union')}
            </p>

            <div itemProp="articleBody">
              <p className="lead">
                <em>
                  {t(
                    'HostFolk is committed to protecting your privacy and ensuring that your personal data is handled securely and responsibly. This Privacy Policy explains how we collect, use, disclose, and protect your information when you use our platform.',
                  )}
                </em>
              </p>

              <h3>{t('1. Who We Are')}</h3>
              <p>
                {t(
                  'HostFolk is a homestay platform that connects host families and international guests for cultural exchange and temporary accommodation. We are the data controller for the personal data you provide when using our services.',
                )}
              </p>

              <h3>{t('2. What Information We Collect')}</h3>
              <ul>
                <li>
                  {t('Identity Data: Name, date of birth, nationality, photo')}
                </li>
                <li>
                  {t('Contact Data: Email address, phone number, home address')}
                </li>
                <li>
                  {t(
                    'Profile Data: Interests, languages spoken, dietary preferences, travel history',
                  )}
                </li>
                <li>
                  {t('Transaction Data: Booking details, payment information')}
                </li>
                <li>
                  {t(
                    'Technical Data: IP address, browser type, device information',
                  )}
                </li>
                <li>
                  {t(
                    'Usage Data: Pages visited, time spent on site, interaction logs',
                  )}
                </li>
              </ul>

              <h3>{t('3. How We Use Your Information')}</h3>
              <ul>
                <li>{t('Facilitate matches between hosts and guests')}</li>
                <li>{t('Process bookings and payments')}</li>
                <li>
                  {t('Communicate with you about your account and activity')}
                </li>
                <li>{t('Improve our platform and user experience')}</li>
                <li>{t('Ensure safety, compliance, and fraud prevention')}</li>
                <li>
                  {t(
                    'Send relevant updates, offers, and newsletters (with your consent)',
                  )}
                </li>
              </ul>

              <h3>{t('4. Legal Basis for Processing')}</h3>
              <ul>
                <li>
                  {t(
                    'Consent: For marketing communications and optional profile details',
                  )}
                </li>
                <li>
                  {t(
                    'Contract: To fulfill our obligations under our Terms and Conditions',
                  )}
                </li>
                <li>
                  {t(
                    'Legal Obligation: To comply with tax, safety, and regulatory requirements',
                  )}
                </li>
                <li>
                  {t(
                    'Legitimate Interest: To improve services and ensure platform security',
                  )}
                </li>
              </ul>

              <h3>{t('5. Data Sharing & Disclosure')}</h3>
              <ul>
                <li>{t('Payment processors and booking partners')}</li>
                <li>
                  {t(
                    'Hosting families or guests (as part of the matching process)',
                  )}
                </li>
                <li>{t('Legal authorities, if required by law')}</li>
                <li>
                  {t(
                    'Service providers who support our operations (e.g., IT, analytics)',
                  )}
                </li>
              </ul>
              <p>{t('We do not sell your personal data to third parties.')}</p>

              <h3>{t('6. International Transfers')}</h3>
              <p>
                {t(
                  'If you are located in the EU or Ireland, your data may be transferred to countries outside the European Economic Area (EEA). We ensure appropriate safeguards are in place, such as Standard Contractual Clauses (SCCs), to protect your data.',
                )}
              </p>

              <h3>{t('7. Data Retention')}</h3>
              <p>
                {t(
                  'We retain your personal data only as long as necessary to fulfill the purposes outlined in this policy, or as required by law. You may request deletion of your data at any time.',
                )}
              </p>

              <h3>{t('8. Your Rights')}</h3>
              <ul>
                <li>{t('Access your personal data')}</li>
                <li>{t('Rectify inaccurate or incomplete data')}</li>
                <li>{t('Erase your data (“right to be forgotten”)')}</li>
                <li>{t('Restrict or object to processing')}</li>
                <li>{t('Data portability')}</li>
                <li>{t('Withdraw consent at any time')}</li>
              </ul>
              <p>
                {t(
                  'To exercise these rights, contact us at privacypolicy@hostfolk.com',
                )}
              </p>

              <h3>{t('9. Cookies & Tracking')}</h3>
              <p>
                {t(
                  'HostFolk uses cookies and similar technologies to enhance your experience. You can manage cookie preferences through your browser settings. For more details, see our Cookie Policy.',
                )}
              </p>

              <h3>{t('10. Security Measures')}</h3>
              <p>
                {t(
                  'We implement appropriate technical and organisational measures to protect your data from unauthorised access, loss, or misuse. These include encryption, secure servers, and access controls.',
                )}
              </p>

              <h3>{t('11. Changes to This Policy')}</h3>
              <p>
                {t(
                  'We may update this Privacy Policy from time to time. Changes will be posted on our website, and we encourage you to review it periodically.',
                )}
              </p>

              <h3>{t('12. Contact Us')}</h3>
              <p>
                Email: privacypolicy@hostfolk.com <br />
                Address: 2 Meetinghouse Lane, Dublin 7, Dublin, Ireland <br />
                Website: www.hostfolk.com
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

Privacy.propTypes = {
  user: userType,
};
